import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import api from "../../../utils/api";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export default function LabSchedule() {
  const queryClient = useQueryClient();
  const [schedule, setSchedule] = useState({});

  const { data, isLoading } = useQuery("lab-schedule", () =>
    api.get("/lab/schedule"),
    {
      onSuccess: (res) => {
        if (res?.schedule) setSchedule(res.schedule);
      },
    }
  );

  const saveMutation = useMutation(
    () => api.put("/lab/schedule", { schedule }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("lab-schedule");
        toast.success("Schedule saved");
      },
    }
  );

  const toggleDay = (day) =>
    setSchedule((prev) => ({
      ...prev,
      [day]: prev[day] ? undefined : { open: "08:00", close: "20:00" },
    }));

  const updateTime = (day, field, value) =>
    setSchedule((prev) => ({
      ...prev,
      [day]: { ...prev[day], [field]: value },
    }));

  return (
    <div className="max-w-2xl space-y-5">
      <div className="card space-y-4">
        <h2 className="font-display font-semibold text-slate-800 text-lg">
          Lab Operating Hours
        </h2>
        <div className="space-y-3">
          {DAYS.map((day) => {
            const active = !!schedule[day];
            return (
              <div key={day} className={`flex items-center gap-4 p-3 rounded-xl border transition-colors ${active ? "bg-primary-50 border-primary-100" : "bg-slate-50 border-slate-100"}`}>
                <button
                  onClick={() => toggleDay(day)}
                  className={`w-10 h-10 rounded-lg text-sm font-semibold transition-colors ${active ? "bg-primary-600 text-white" : "bg-white border border-slate-200 text-slate-500"}`}
                >
                  {day.slice(0, 3)}
                </button>
                {active ? (
                  <div className="flex items-center gap-3 flex-1">
                    <input
                      type="time"
                      value={schedule[day]?.open || ""}
                      onChange={(e) => updateTime(day, "open", e.target.value)}
                      className="input-field w-auto"
                    />
                    <span className="text-slate-400 text-sm">to</span>
                    <input
                      type="time"
                      value={schedule[day]?.close || ""}
                      onChange={(e) => updateTime(day, "close", e.target.value)}
                      className="input-field w-auto"
                    />
                  </div>
                ) : (
                  <span className="text-slate-400 text-sm">Closed</span>
                )}
              </div>
            );
          })}
        </div>
        <button onClick={() => saveMutation.mutate()} disabled={saveMutation.isLoading} className="btn-primary">
          {saveMutation.isLoading ? "Saving…" : "Save Schedule"}
        </button>
      </div>
    </div>
  );
}
